/* eslint-disable import/no-anonymous-default-export */

import highmarkRulesTypes from './high-mark-rules.type';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	addHighmarkRulesResponse: null,
	fetchHighmarkRulesResponse: null,
	fetchHighmarkRulesArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD HIGHMARK RULES START *********************** */
		case highmarkRulesTypes.ADD_HIGHMARK_RULES_SUCCESS:
			return { ...state, addHighmarkRulesResponse: action.payload };

		case highmarkRulesTypes.ADD_HIGHMARK_RULES_FAILURE:
			return { ...state, addHighmarkRulesResponse: action.payload };

		case highmarkRulesTypes.ADD_HIGHMARK_RULES_RESPONSE_CHANGED:
			return { ...state, addHighmarkRulesResponse: null };
		/** ***************** ADD HIGHMARK RULES END *********************** */

		/** ***************** FETCH HIGHMARK RULES START *********************** */
		case highmarkRulesTypes.FETCH_HIGHMARK_RULES_SUCCESS:
			return {
				...state,
				fetchHighmarkRulesResponse: action.payload,
				fetchHighmarkRulesArr: docodeHexResponse(action.payload, 'FetchHighmarkRulesKey'),
			};

		case highmarkRulesTypes.FETCH_HIGHMARK_RULES_FAILURE:
			return {
				...state,
				fetchHighmarkRulesResponse: action.payload,
				fetchHighmarkRulesArr: [],
			};

		case highmarkRulesTypes.FETCH_HIGHMARK_RULES_RESPONSE_CHANGED:
			return { ...state, fetchHighmarkRulesResponse: null };
		/** ***************** FETCH HIGHMARK RULES END *********************** */
		default:
			return state;
	}
};
